import './RAAccordionButton.scss';

// @ vendors
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { recordEventCustomOnly } from 'utilities/uTagging';
// @ constants
import { SUITABILITY_TEST_STEP_4 } from 'constants/RAConstants';
import { TEST_PROCESS_STEP_STEP_4, EVENT_CATEGORY_SUITABILITY_TEST } from 'constants/uTagConstants/RAConstants';

export const RAAccordionButton = ({
    formActions,
    id,
    profileModel,
    rowId,
    rowIndex,
    validateStep,
    label,
    model,
    selectedOption,
    selectAccordionButton,
    title,
}) => {
    const accordionButtonClass = classNames('ra-accordion-button', {
        'ra-accordion-button--selected': id === selectedOption,
    });

    const handleClick = () => {
        selectAccordionButton(rowId, id);
        formActions.change(`${profileModel}.${rowId}`, id);

        validateStep && validateStep(SUITABILITY_TEST_STEP_4);

        const buttonEventTag = () => {
            const zeroPad = (num, places) => String(num).padStart(places, '0');

            const answerId = id.replace(/\D/g, '');
            return `${zeroPad(rowIndex + 1, 2)} ${title} - answer_${answerId - 1}`;
        };

        recordEventCustomOnly({
            accionEvento: TEST_PROCESS_STEP_STEP_4,
            categoriaEvento: EVENT_CATEGORY_SUITABILITY_TEST,
            etiquetaEvento: buttonEventTag(),
        });
    };

    useEffect(() => {
        validateStep && validateStep(SUITABILITY_TEST_STEP_4);
    }, []);

    return (
        <div className={accordionButtonClass} name={model} onClick={handleClick}>
            {label}
        </div>
    );
};

RAAccordionButton.propTypes = {
    formActions: PropTypes.object.isRequired,
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    model: PropTypes.string.isRequired,
    profileModel: PropTypes.string.isRequired,
    rowId: PropTypes.string.isRequired,
    rowIndex: PropTypes.number,
    selectAccordionButton: PropTypes.func.isRequired,
    selectedOption: PropTypes.string.isRequired,
    userProfile: PropTypes.object.isRequired,
    validateStep: PropTypes.func,
    title: PropTypes.string,
};
